// ═══════════════════════════════════════════════════════════════
// Symboly (sekce 2.3 Symboly, Fáze 2) — sada speciálních znaků k vložení.
//
// Vkládají se jako obyčejný text (Unicode), takže projdou exportem do DOCX
// bez jakékoli zvláštní logiky (jsou to jen znaky v runu). Výběr pokrývá
// nejčastější potřeby cílové skupiny (právní/daňové kanceláře v CZ/SK):
// měny, právní/typografické značky, matematika, šipky, řecká abeceda,
// diakritika a interpunkce, které nejsou na běžné klávesnici.
// ═══════════════════════════════════════════════════════════════

export interface SymbolCategory {
  id: string;
  label: string;
  chars: string[];
}

export const SYMBOL_CATEGORIES: SymbolCategory[] = [
  {
    id: 'common',
    label: 'Časté',
    chars: [
      '€', '$', '£', '¥', '¢', '§', '©', '®', '™', '°', '№', '•', '…', '‰',
      '†', '‡', '¶', '∅', '≈', '≠', '±', '×', '÷', '√', '∞', '∑', '∏', '∫',
    ],
  },
  {
    id: 'punctuation',
    label: 'Interpunkce',
    chars: [
      '„', '“', '”', '‚', '‘', '’', '»', '«', '›', '‹', '–', '—', '‐', '‑',
      '·', '‧', '⁂', '※', '¿', '¡', '⸿',
    ],
  },
  {
    id: 'currency',
    label: 'Měny',
    chars: ['€', '$', '£', '¥', '¢', '₽', '₩', '₴', '₺', '₹', '₿', 'Kč', 'zł', '₪', '₫', '₦'],
  },
  {
    id: 'math',
    label: 'Matematika',
    chars: [
      '±', '×', '÷', '∓', '⋅', '∘', '√', '∛', '∜', '∞', '∝', '≈', '≠', '≡',
      '≤', '≥', '≪', '≫', '∈', '∉', '⊂', '⊃', '∪', '∩', '∅', '∀', '∃', '∄',
      '∑', '∏', '∫', '∮', '∂', '∇', '∆', '°', '′', '″', 'π', 'µ', 'Ω', '‰',
    ],
  },
  {
    id: 'arrows',
    label: 'Šipky',
    chars: [
      '←', '→', '↑', '↓', '↔', '↕', '↖', '↗', '↘', '↙', '⇐', '⇒', '⇑', '⇓',
      '⇔', '↩', '↪', '⟶', '⟵', '⟷', '➜', '➔', '►', '◄', '▲', '▼',
    ],
  },
  {
    id: 'greek',
    label: 'Řecká abeceda',
    chars: [
      'α', 'β', 'γ', 'δ', 'ε', 'ζ', 'η', 'θ', 'ι', 'κ', 'λ', 'μ', 'ν', 'ξ',
      'ο', 'π', 'ρ', 'σ', 'τ', 'υ', 'φ', 'χ', 'ψ', 'ω',
      'Α', 'Β', 'Γ', 'Δ', 'Θ', 'Λ', 'Ξ', 'Π', 'Σ', 'Φ', 'Ψ', 'Ω',
    ],
  },
  {
    id: 'legal',
    label: 'Právní a značky',
    chars: ['§', '©', '®', '™', '℗', '№', '†', '‡', '☑', '☐', '☒', '✓', '✔', '✗', '✘', '★', '☆', '⚠'],
  },
];
